import request from '@/utils/request'

// Get dashboard main data
export function getDashboardMain(params) {
  return request({
    url: '/api/admin/Dashboard',
    method: 'get',
    params
  })
}
